// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1BlGR","content":"styles_content__z4Pkf","buttonIcon":"styles_buttonIcon__1RroQ","assignmentDescription":"styles_assignmentDescription__uQrNL"};